import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { toIdr } from '@/libs/utils/format'

import { itemMasterDetail } from '@/features/item/api'
import { ItemMasterTypeBadge } from '@/features/item/components/common'
import { RecipeItemForm } from '@/features/recipe/components/recipe-form'

export const Route = createFileRoute('/_app/inventory/master/$id/recipe')({
	loader: async ({ context: { qc }, params: { id } }) => {
		await qc.ensureQueryData(itemMasterDetail.qry({ id }))
	},
	component: RouteComponent,
})

function RouteComponent() {
	const { item } = useItem()

	return (
		<PageLayout>
			<PageLayout.Header
				breadcrumbs={[
					['/inventory', 'Inventory'],
					['/inventory/master', 'Master'],
					['/inventory/master/$id', item.name],
					[Route.fullPath, 'Resep'],
				]}
			/>
			<ItemInfoSection />
			<PageCard>
				<PageCard.Header title="Resep item" />
				<RecipeItemForm />
			</PageCard>
		</PageLayout>
	)
}

function ItemInfoSection() {
	const { item } = useItem()
	return (
		<PageCard>
			<PageCard.Header title={`Info Bahan`} />
			<PageCard.ContentRow title="Nama" value={item.name} />
			<PageCard.ContentRow
				title="Jenis Bahan"
				value={<ItemMasterTypeBadge type={item.type} />}
			/>
			<PageCard.ContentRow
				title="Default Cost"
				value={`${toIdr(item.baseCost)}`}
			/>
		</PageCard>
	)
}

function useItem() {
	const { id } = Route.useParams()
	const { item } = useSuspenseQuery(itemMasterDetail.qry({ id })).data

	return {
		id,
		item,
	}
}
